/* https://github.com/setaman/vue-ellipse-progress#installation */
import { app } from "@/main";
import veProgress from "vue-ellipse-progress";

app.use(veProgress);
